import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { ChartCard } from './ChartCard';
import { tokens } from './tokens';
import type { FallbackTable as FallbackTableData } from './copilotTypes';

/** A numeric cell gets right-aligned + tabular-nums + thousands separators; everything else stays left. */
const isNumber = (v: string | number | null): v is number => typeof v === 'number';

export function FallbackTable({ title, table }: { title: string; table: FallbackTableData }) {
  const { columns, rows } = table;

  return (
    <ChartCard title={title}>
      <TableContainer sx={{ border: `1px solid ${tokens.surface.border}`, borderRadius: '12px' }}>
        <Table size="small" sx={{ fontFamily: tokens.fontFamily }}>
          <TableHead>
            <TableRow>
              {columns.map((col, ci) => (
                <TableCell
                  key={ci}
                  sx={{
                    fontFamily: tokens.fontFamily,
                    fontSize: 12,
                    fontWeight: 600,
                    color: tokens.text.secondary,
                    bgcolor: tokens.surface.page,
                    borderBottom: `1px solid ${tokens.surface.border}`,
                    py: 1,
                    px: 1.5,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, ri) => (
              <TableRow key={ri}>
                {row.map((cell, ci) => {
                  const numeric = isNumber(cell);
                  return (
                    <TableCell
                      key={ci}
                      align={numeric ? 'right' : 'left'}
                      sx={{
                        fontFamily: tokens.fontFamily,
                        fontSize: 13,
                        color: cell == null ? tokens.text.secondary : tokens.text.primary,
                        borderBottom: `1px solid ${tokens.surface.border}`,
                        py: 0.75,
                        px: 1.5,
                        ...(numeric ? { fontVariantNumeric: 'tabular-nums' } : null),
                      }}
                    >
                      {cell == null ? '—' : numeric ? cell.toLocaleString() : cell}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </ChartCard>
  );
}
